// AdvancedMarker content for vue3-google-map; styles (.map-marker*) are in css/app.css
export const createMarkerElement = (
  color,
  count = null,
  isSpecial = false,
  shape = "circle",
  priority = null,
  hasNoPlannedDate = false,
) => {
  const wrapper = document.createElement("div")
  wrapper.classList.add("map-marker-wrapper")
  const element = document.createElement("div")
  element.classList.add("map-marker")
  if (shape === "square") element.classList.add("map-marker-square")
  else if (shape === "triangle") element.classList.add("map-marker-triangle")
  if (hasNoPlannedDate) element.classList.add("map-marker-no-date")
  element.style.backgroundColor = color
  element.textContent = count?.toString()
  wrapper.appendChild(element)
  if (isSpecial) {
    const badge = document.createElement("div")
    badge.classList.add("map-special-badge")
    wrapper.appendChild(badge)
  }
  if (priority !== null) {
    const priorityBadge = document.createElement("div")
    priorityBadge.classList.add("map-priority-badge")
    if (priority === 1) priorityBadge.classList.add("map-priority-badge-danger")
    priorityBadge.textContent = priority.toString()
    wrapper.appendChild(priorityBadge)
  }
  return wrapper
}
